/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Monthly_Plan_TitleInputs */

const en_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Lighter with the Monthly Plan`)
};

const ar_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ بخفة مع الخطة الشهرية`)
};

const de_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte entspannter mit dem Monatsplan`)
};

const es_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza más ligero con el plan mensual`)
};

const fr_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez en douceur avec l'offre mensuelle`)
};

const it_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia in modo più leggero con il piano mensile`)
};

const ja_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`気軽に始める月額プラン`)
};

const ko_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 가볍게 시작하는 월간 플랜`)
};

const pt_br_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece de forma mais leve com o plano mensal`)
};

const ru_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лёгкий старт с месячным планом`)
};

const th_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มต้นแบบสบายๆ กับแผนรายเดือน`)
};

const tr_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık planla daha hafif başlayın`)
};

const zh_cn_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试试更轻松的连续包月`)
};

const zh_tw_try_monthly_plan_title = /** @type {(inputs: Try_Monthly_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試試更輕鬆的月方案`)
};

/**
* | output |
* | --- |
* | "Start Lighter with the Monthly Plan" |
*
* @param {Try_Monthly_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const try_monthly_plan_title = /** @type {((inputs?: Try_Monthly_Plan_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Monthly_Plan_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_try_monthly_plan_title(inputs)
	if (locale === "ar") return ar_try_monthly_plan_title(inputs)
	if (locale === "de") return de_try_monthly_plan_title(inputs)
	if (locale === "es") return es_try_monthly_plan_title(inputs)
	if (locale === "fr") return fr_try_monthly_plan_title(inputs)
	if (locale === "it") return it_try_monthly_plan_title(inputs)
	if (locale === "ja") return ja_try_monthly_plan_title(inputs)
	if (locale === "ko") return ko_try_monthly_plan_title(inputs)
	if (locale === "pt_br") return pt_br_try_monthly_plan_title(inputs)
	if (locale === "ru") return ru_try_monthly_plan_title(inputs)
	if (locale === "th") return th_try_monthly_plan_title(inputs)
	if (locale === "tr") return tr_try_monthly_plan_title(inputs)
	if (locale === "zh_cn") return zh_cn_try_monthly_plan_title(inputs)
	return zh_tw_try_monthly_plan_title(inputs)
});